<template>
<div class="page_toutiao page_dingzhi page_map">
    <!-- 筛选 -->
    <div class="top_wrap relative">
        <div class="index_top">
            <div class="PageSearch page-search">
                <van-row type="flex" justify="space-start">
                    <van-col v-if="searchlefticon" class="left_col">
                        <van-icon :name="searchlefticon" size=".59rem" style="width:.59rem; height:.63rem; margin:.12rem .35rem 0 .5rem;" />
                    </van-col>
                    <van-col :class="searchlefticon ? 'search_col': searchrighticon ? 'search_col_big': 'search_col_big_rise'">
                        <van-cell-group class="search_field">
                            <van-field v-model="search_value" :placeholder="placeholder">
                                <van-icon slot="right-icon" :name="righticon" @click="search" />
                            </van-field>
                        </van-cell-group>
                    </van-col>
                    <van-col v-if="searchrighticon != ''" class="right_col" @click="clicksearchright">
                        <van-icon :name="searchrighticon" size=".55rem" style="width:.55rem; height:.55rem; margin:.12rem 0 0 .5rem;" />
                    </van-col>
                </van-row>
            </div>
            <!-- banner -->
            <van-swipe :autoplay="3000" class="swiper_style1">
                <van-swipe-item>
                    <van-image width="100%" height="100%" :src="publicPath+'statics/images/dingzhi/banner_shequ.png'" />
                </van-swipe-item>
            </van-swipe>
        </div>
        <!-- 当前页筛选 -->
        <div class="search" v-if="search_status">
            <!-- 选择分类 -->
            <div class="search_fenlei">
                <div class="search_title">选择分类</div>
                <ul class="search_list clearfix">
                    <li :class="item.active ? 'search_item f-l cate active': 'search_item f-l cate'" v-for="item in cateList" :key="item.id" :data-id="item.id" @click="clickCate(item)">{{item.title}}</li>
                </ul>
            </div>
            <!-- 重置 确定 -->
            <div class="search_actions">
                <div class="search_action" @click="reset">重置</div>
                <div class="search_action" @click="submit">确定</div>
            </div>
        </div>
    </div>
    <!-- 列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
            <div class="list shequ">
                <div class="item" v-for="item in dataList" :key="item.id">
                    <div class="item_t" @click="goDetail(item)">
                        <div class="item_t_l" >
                            <img :src="item.thumb ? ($publicData.withHttpStart(item.thumb) ? item.thumb : imageUrl+item.thumb) : $publicData.defaultTouxiang" alt="" class="tu">
                            <div class="text">
                                <div class="text_t column">
                                    <div class="title slh_s">{{item.username}}</div>
                                    <div class="tag">{{ item.cate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item_title slh" @click="goDetail(item)">{{ item.title }}</div>
                    <div class="item_tu more" @click="goDetail(item)">
                        <div class="tu_wrap" v-for="(image,index) in item.images_hide ? item.imagesSlice : item.images" :key="index" >
                            <van-image fit="cover" :src="imageUrl+image" class="tu" :show-error="false" :show-loading="false" />
							<div class="mark" v-if="item.images_hide && index == 2">{{'+'+ (item.images.length -3)}}</div>
                        </div>
                    </div>
                    <div class="item_bottom" @click="goDetail(item)">
                        <div class="view">浏览{{'('+ item.look_num +')'}} </div>
                        <div class="time">{{ item.create_time }}</div>
                    </div>
                </div>
            </div>
        </van-list>
    </van-pull-refresh>
    <!-- 发布按钮 -->
    <div class="post" @click="toDingzhiPublish">
        <img :src="publicPath+'statics/images/icon_fabu.png'" alt="" class="">
    </div>
    <!-- 遮罩层 -->
    <van-overlay :show="search_status" class="overlay" />
    <!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            searchlefticon: '', // 搜索栏左侧图标
            searchrighticon: process.env.BASE_URL + 'statics/images/icon_shaixuan_white.png', // 搜索栏右侧图标
            search_value: '', // 搜索值
            readonly: true, // 搜索栏只读
            placeholder: '请输入想要查找的内容',
            righticon: process.env.BASE_URL + '/statics/images/search_ico.png', // 搜索框搜索图标
            publicPath: process.env.BASE_URL,
            token: null,
            cateList: null, // 分类
            search_status: false, // 筛选层是否展开
            pages: {
                page: 1,
                size: 10
            },
            cate_id: null, // 分类id
            loading: false,
            finished: false,
            refreshing: false,
            dataList: [], // 列表
            bigTuShow: false,
            bigTuIndex: 0,
            bigTuImgArr: null,
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '发布定制'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
        // 获取分类
        this.getCateList()
        // 获取列表
        this.onRefresh()
    },
    methods: {
        // 分类
        getCateList() {
            var params = {
                token: this.token
            }
            this.$api.dingzhi.catelist(params).then(res => {
                if (res.code == 200) {
                    var cateList = res.result
                    for (var i in cateList) {
                        cateList[i].active = 0
                    }
                    this.cateList = cateList
                }
            })
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false;

            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.pages.page = 1
            this.getData();
        },
        // 定制列表
        getData() {
            var params = {
                token: this.token,
                page: this.pages.page,
                size: this.pages.size
            }
            if (this.search_value && this.search_value != undefined && this.search_value != '') {
                params.title = this.search_value
            }
            if (this.cate_id) {
                params.custom_made_cate_id = this.cate_id
            }
            this.$api.dingzhi.comunitylist(params).then(res => {
                if (res.code == 200) {
                    if (this.pages.page == 1) {
                        this.dataList = []
                    }
                    var list = []
                    list = res.result.list
                    if (list.length != 0) {
                        for (var i in list) {
							var item = list[i]
							item.create_time = item.created_at.split(' ')[0]
							if(item.album){
								item.images = item.album.split(",");
								if (item.images && item.images.length > 3) {
									item.images_hide = 1
									item.imagesSlice = item.images.slice(0, 3)
								}
							}
							// 如果用户名是手机号,隐掉中间4位
							if(/^1[3456789]\d{9}$/.test(item.username)){
								var tel = item.username
								item.username = tel.replace(/^(\d{3})\d{4}(\d{4})$/,'$1****$2')
							}
                            this.dataList.push(item)
                        }
                    } else {
                        this.refreshing = false
						this.finished = true
                    }
                } else {
                    this.refreshing = false
					this.finished = true
                }
				this.loading = false
				this.refreshing = false
                this.pages.page++
            })
        },
        // 点击右侧图标
        clicksearchright() {
            // 没有右侧图标
            this.search_status = !this.search_status;
        },

        // 搜索关键字
        search() {
            this.onRefresh()
        },
        // 选择分类
        clickCate(item) {
            item.active = !item.active
            for (var i in this.cateList) {
                if (this.cateList[i].id == item.id) {
                    if (item.active) {
                        this.cateList[i].active = 1
                        this.cate_id = item.id
                    } else {
                        this.cateList[i].active = 0
                        this.cate_id = null
                    }

                } else {
                    this.cateList[i].active = 0
                }
            }
            // console.log('this.cateList',this.cateList)
        },
        // 重置
        reset() {
            for (var i in this.cateList) {
                this.cateList[i].active = 0
            }
            this.cate_id = null
        },
        // 确定
        submit() {
            this.search_status = false
            this.onRefresh()
        },
        // 去详情
        goDetail: function (item) {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': this.$publicData.clientUrl + '/dingzhi/detail/user?id=' + item.id
                    }
                }
                this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.$router.push({
                    path: '/dingzhi/detail/user',
                    query: {
						id: item.id
					}
                })
            }
        },
        // 展开大图 
        zhanshitupian(item, arr, index, id) {
			for(let j in arr){
				arr[j] = this.imageUrl+arr[j];
			}
            if (index == 2 && item.images_hide) {
                for (var i in this.dataList) {
                    if (this.dataList[i].id == item.id) {
                        this.dataList[i].images_hide = 0
                        return
                    }
                }
                return
			}else{
				// 进入详情
				this.goDetail(item)
			}
			// 关闭展开大图的功能
            // this.bigTuImgArr = arr;
            // this.bigTuIndex = index;
            // this.bigTuShow = true;
        },
        // 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
        // 发布定制
        toDingzhiPublish() {
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var memberParams = {
                    data: {},
                };
                this.$bridge.callhandler("sdjy://member/memberInfo", memberParams,
                    (data) => {
                        if (data.code == 200) {
                            var params = {
								'data': {
									'url': this.$publicData.clientUrl + '/dingzhi/publish?is_tradesman=' + 0
								}
							}
							this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

							})
                        }
                    }
                );
            } else {
                if (!this.token) {
                    localStorage.setItem('redirect', this.$router.currentRoute.fullPath)
                    this.$router.push({
                        path: '/login'
                    })
                    return
                }
                this.$router.push({
                    path: '/dingzhi/publish',
                    query: {
                        is_tradesman: 0 // 从社区页面进行发布,都是作为用户角色的,跟他是不是匠人无关
                    }
                })
            }
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
